"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NowportsPanama = void 0;
exports.NowportsPanama = {
    id: 'nowportsPanama',
    companyName: 'Nowports Panama',
    transportModes: ['sea', 'air'],
    freightGate: {
        isOnboarded: true,
        realm: 'nowportsPanama',
    },
    isInternal: false,
    isActive: true,
    countries: ['PA'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTm93cG9ydHNQYW5hbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvYWdlbnRzL2RhdGEvTm93cG9ydHNQYW5hbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxjQUFjLEdBQVU7SUFDakMsRUFBRSxFQUFFLGdCQUFnQjtJQUNwQixXQUFXLEVBQUUsaUJBQWlCO0lBQzlCLGNBQWMsRUFBRSxDQUFDLEtBQUssRUFBRSxLQUFLLENBQUM7SUFDOUIsV0FBVyxFQUFFO1FBQ1QsV0FBVyxFQUFFLElBQUk7UUFDakIsS0FBSyxFQUFFLGdCQUFnQjtLQUMxQjtJQUNELFVBQVUsRUFBRSxLQUFLO0lBQ2pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsU0FBUyxFQUFFLENBQUMsSUFBSSxDQUFDO0NBQ3BCLENBQUEifQ==